
import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { TestAdminTokenResponse, UpdateAdminInfoRequest } from "./models";
import { GetCbuResponse } from "../../../pages/Dashboard/Api/CBU/models";
import { BalanceResponse } from "../../../pages/Dashboard/Api/Admin/models";


export const testAdminToken = async (): Promise<TestAdminTokenResponse> => {
    const config = getConfig()
    try {
        let result = await axios.post(`/admin/testAdminToken`, {}, config)
        return result.data;
    } catch (error) {
        console.log(error)
        return error as TestAdminTokenResponse
    }


}

export const fetchBotCBUInformation = async (): Promise<GetCbuResponse> => {
    const config = getConfig()
    try {
        let result = await axios.get(`/admin/getBotCBUInfo`, config)

        return result.data;
    } catch (error) {
        return error as GetCbuResponse
    }
}


export const fetchBalanceAsAdmin = async (): Promise<BalanceResponse> => {
    const config = getConfig()
    try {
        let result = await axios.get(`/admin/balance`, config)

        return result.data;
    } catch (error) {
        return error as BalanceResponse
    }
}


export const updateAdminInfo = async (adminInfo: UpdateAdminInfoRequest): Promise<any> => {
    const config = getConfig()
    try {
        let result = await axios.post(`/admin/updateAdmin`, adminInfo, config)

        return result.data;
    } catch (error) {
        return error as any
    }
}

